"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JLData = void 0;
exports["default"] = Analytics;
exports.setJLData = exports.getTypeForEvent = exports.getAddInfoForEvent = exports.dispatchAnalyticsEvent = void 0;
var _react = require("react");
var _constants = require("../../utils/constants");
function Analytics() {
  var trackClick = function trackClick(e) {
    var clickedElement = e.target.closest('[data-event]');
    if (clickedElement !== null) {
      var eventType = clickedElement.getAttribute('data-event');
      dispatchAnalyticsEvent(eventType, getAddInfoForEvent(eventType, clickedElement));
    }
  };
  (0, _react.useEffect)(function () {
    document.addEventListener('click', trackClick);
    return function () {
      window.removeEventListener('click', trackClick);
    };
  }, []);
  return null;
}
var JLData = exports.JLData = function JLData(_ref) {
  var metadata = _ref.metadata;
  (0, _react.useEffect)(function () {
    setJLData(metadata);
  }, [metadata]);
  return null;
};
var setJLData = exports.setJLData = function setJLData(metadata) {
  var pageData = {
    page: {
      pageInfo: {
        breadcrumb: window.location.pathname.split('/').filter(function (crumb) {
          return crumb.length;
        }),
        layoutType: 'Mobile',
        pageCanonicalURL: metadata.canonicalUrl || window.location.href,
        pageName: window.location.pathname,
        pageType: metadata.pageType || '',
        site: window.location.hostname,
        siteProvider: metadata.siteProvider || ''
      },
      category: {
        siteSection: metadata.siteSection || '',
        siteType: metadata.siteType || '',
        siteProduct: metadata.siteProduct || '',
        siteRegion: 'Hub'
      },
      locale: {
        country: 'UK',
        language: 'en-gb',
        currency: 'gbp'
      },
      productPages: {
        productId: metadata.siteProduct || '',
        brand: metadata.productBrand || ''
      },
      article: {
        name: metadata.articleName || '',
        type: metadata.articleType || ''
      },
      videos: []
    },
    error: {},
    eventData: {}
  };
  if (window.innerWidth >= _constants.breakpoints.tablet) {
    if (window.innerWidth < _constants.breakpoints.desktop) {
      pageData.page.pageInfo.layoutType = 'Tablet';
    } else {
      pageData.page.pageInfo.layoutType = 'Desktop';
    }
  }
  window.jlData = pageData;
  return window.jlData;
};
var dispatchAnalyticsEvent = exports.dispatchAnalyticsEvent = function dispatchAnalyticsEvent(action, data) {
  return new Promise(function (resolve) {
    var event = new CustomEvent('dataStateChange', {
      bubbles: true,
      detail: {
        action: action,
        type: getTypeForEvent(action),
        addInfo: data
      }
    });
    document.body.dispatchEvent(event);
    resolve(event);
  });
};
var getTypeForEvent = exports.getTypeForEvent = function getTypeForEvent(action) {
  switch (action) {
    case 'accordionOpen':
      return 'Accordion';
    case 'ctaClick':
      return 'Call To Action (CTA)';
    case 'footerNavClick':
      return 'Footer Nav';
    case 'headerNavClick':
      return 'Header Nav';
    case 'loginMenuClick':
    case 'loginMenuOpen':
      return 'Login Menu';
    case 'stickyNavigation':
      return 'Sticky Navigation';
    case 'tabClick':
      return 'Tab';
    case 'currencyConverterOrderNowClick':
      return 'Foreign Currency Converter';
    case 'currencyConverterInteraction':
      return 'Foreign Currency Converter';
    default:
      return '';
  }
};
var getAddInfoForEvent = exports.getAddInfoForEvent = function getAddInfoForEvent(action, clickedElement) {
  var _clickedElement$close;
  switch (action) {
    case 'accordionOpen':
      return {
        accordionName: clickedElement.getAttribute('data-name')
      };
    case 'ctaClick':
      return {
        linkID: "".concat(clickedElement.getAttribute('data-component'), ":").concat(clickedElement.textContent),
        linkSection: clickedElement.getAttribute('data-section'),
        linkLocation: clickedElement.getAttribute('data-location'),
        linkText: clickedElement.textContent,
        linkUrl: 'href' in clickedElement ? clickedElement.href : ''
      };
    case 'footerNavClick':
    case 'headerNavClick':
      return {
        linkText: clickedElement.textContent,
        linkUrl: 'href' in clickedElement ? clickedElement.href : '',
        navBarSection: clickedElement.getAttribute('data-section')
      };
    case 'loginMenuClick':
      return {
        linkText: clickedElement.textContent,
        linkUrl: 'href' in clickedElement ? clickedElement.href : ''
      };
    case 'socialMedia':
      return {
        linkText: clickedElement.getAttribute('data-text'),
        linkUrl: 'href' in clickedElement ? clickedElement.href : ''
      };
    case 'stickyNavigation':
      return {
        linkID: "".concat(clickedElement.getAttribute('data-component'), ":").concat(clickedElement.textContent),
        linkLocation: clickedElement.getAttribute('data-location'),
        linkText: clickedElement.textContent,
        linkUrl: 'href' in clickedElement ? clickedElement.href : ''
      };
    case 'tabClick':
      return {
        tabName: clickedElement.getAttribute('data-text'),
        tabPosition: clickedElement.getAttribute('data-position'),
        tabGroupName: (_clickedElement$close = clickedElement.closest('[data-section]')) === null || _clickedElement$close === void 0 ? void 0 : _clickedElement$close.getAttribute('data-section'),
        tabNumItems: clickedElement.getAttribute('data-items')
      };
    default:
      return {};
  }
};